var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrditos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.33331H3.33335C2.40835 3.33331 1.67502 4.07498 1.67502 4.99998L1.66669 15C1.66669 15.925 2.40835 16.6667 3.33335 16.6667H16.6667C17.5917 16.6667 18.3334 15.925 18.3334 15V4.99998C18.3334 4.07498 17.5917 3.33331 16.6667 3.33331ZM16.6667 15H3.33335V9.99998H16.6667V15ZM16.6667 6.66665H3.33335V4.99998H16.6667V6.66665Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrditos);
export default __webpack_public_path__ + "static/media/Créditos.22f858ebe4a11c9f432014f3abeb2e7f.svg";
export { ForwardRef as ReactComponent };